export default __webpack_public_path__ + "static/media/simbolo_claro.c11b7685.svg";